import { type Client, graphql, prefetch } from "@opensea/graphql"

export const CollectionItemsCountQuery = graphql(`
  query CollectionItemsCountQuery(
    $collectionSlug: String!
    $filter: CollectionItemsFilter
  ) {
    collectionItemsCount(collectionSlug: $collectionSlug, filter: $filter) {
      count
      hasMore
    }
  }
`)

export const CollectionItemsCountSubscription = graphql(`
  subscription CollectionItemsCountSubscription($slug: String!) {
    collectionBySlug(slug: $slug) {
      __typename
      ... on Collection {
        id
        stats {
          totalSupply
          uniqueItemCount
        }
      }
    }
  }
`)

export const ListedCollectionItemsCountSubscription = graphql(`
  subscription ListedCollectionItemsCountSubscription($slug: String!) {
    collectionBySlug(slug: $slug) {
      __typename
      ... on Collection {
        id
        stats {
          listedItemCount
        }
      }
    }
  }
`)

export const prefetchCollectionItemsCountQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionItemsCountQuery, { collectionSlug })
}
